import React from 'react';

import { AssetDetails } from '@/api/asset/asset-schema';

import { AssetLogotype } from '../asset-logotype/AssetLogotype';
import * as S from './AssetCard.styles';

export interface AssetCardProps {
  assetDetails: AssetDetails;
}

export const AssetCard = ({ assetDetails }: AssetCardProps) => {
  const { ticker, company_name, logo_urls } = assetDetails;

  return (
    <S.AssetCardRoot data-testid="asset-card">
      <S.Logotype>
        <AssetLogotype name={company_name} logoUrl={logo_urls.png_light} />
      </S.Logotype>
      <div>
        <S.Title>{company_name}</S.Title>
        <S.Subtitle>{ticker}</S.Subtitle>
      </div>
    </S.AssetCardRoot>
  );
};
